import logo from "@/media/logo.png";
import Discover from "@/svg/discover.svg?react";
import JCB from "@/svg/jcb.svg?react";
import Mastercard from "@/svg/mastercard.svg?react";
import PayPal from "@/svg/paypal.svg?react";
import PaysafeCard from "@/svg/paysafecard.svg?react";
import Visa from "@/svg/visa.svg?react";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import { USP } from "./USPs";

function PaymethodFrame({className, children}: {
    className?: string,
    children: React.ReactNode
}) {
    return (
        <div className={clsx("h-12 flex items-center rounded-full px-5 bg-linear-to-b via-95% from-[#FFECF4] via-[#E7CAD5] to-[#F4D5E1] font-semibold text-xl text-text-100", className)}>
            {children}
        </div>
    )
}

export default function PlanFrame({
    className,
    title,
    children
}: {
    className?: string,
    title: React.ReactNode,
    children: React.ReactNode
}) {
    const {t} = useTranslation();

    return (
        <div className={clsx("flex flex-col items-center px-4", className)}>
            <div className="flex flex-col items-center gap-6">
                <img src={logo} className="h-15" />
                <h1 className="heading-2xl text-center">{t("selectPlan.title")}</h1>
                <h2 className="mt-5 heading-m text-center">{t("selectPlan.subtitle")}</h2>
                <div className="flex gap-x-8 gap-y-3.5 items-center flex-wrap justify-center">
                    <USP variant="pink">{t("signUp.usp.discretion")}</USP>
                    <USP variant="pink">{t("signUp.usp.noHiddenCosts")}</USP>
                    <USP variant="pink">{t("signUp.usp.immediate")}</USP>
                </div>
            </div>
            <h2 className="mt-17.5 heading-l text-center">{title}</h2>
            {children}
            <h3 className="mt-12 heading-m text-center">{t("selectPlan.paymentsTitle")}</h3>
            <div className="mt-9 flex gap-4 flex-wrap justify-center">
                <PaymethodFrame className="gap-3">
                    <div className="gap-1.5 flex h-6">
                        <Visa />
                        <Mastercard />
                        <Discover />
                        <JCB />
                    </div>
                    {t("selectPlan.paymentsCreditCard")}
                </PaymethodFrame>
                <PaymethodFrame>
                    <PayPal />
                </PaymethodFrame>
                <PaymethodFrame>
                    <PaysafeCard />
                </PaymethodFrame>
            </div>
            <p className="mt-7 body-m text-center text-text-700">{t("selectPlan.provider")}</p>
        </div>
    )
}